import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Btn, GoIcon, Wrapper, PageBtn, DotsWrapper } from './styled';
var Pagination = function (_a) {
    var onPageChange = _a.onPageChange, _b = _a.itemPerPage, itemPerPage = _b === void 0 ? 3 : _b, _c = _a.itemCount, itemCount = _c === void 0 ? 0 : _c, page = _a.page, _d = _a.radius, radius = _d === void 0 ? 5 : _d, _e = _a.rate, rate = _e === void 0 ? 4 : _e, customPaginationHandler = _a.customPaginationHandler;
    var setPage = useCallback(function (number) { return function () {
        if (customPaginationHandler) {
            customPaginationHandler(number, itemPerPage);
            return;
        }
        if (onPageChange) {
            onPageChange(number, itemPerPage);
        }
    }; }, [itemPerPage, onPageChange, customPaginationHandler]);
    var pageX = page !== null && page !== void 0 ? page : 1;
    var pageCount = Math.max(Math.ceil(itemCount / itemPerPage), 1);
    var arrayOfPages = useMemo(function () {
        var pageNumbers = Array.from({ length: pageCount }, function (_, i) { return i + 1; });
        // first and last page are still visible
        // if number of pages is less than 6 (display all pages without dots and duplication of first and last char)
        if (pageCount < radius + 1) {
            return pageNumbers.slice(1, pageCount - 1);
            // if current page is less than radius (display first radius pages)
        }
        else if (pageX < radius) {
            return pageNumbers.slice(1, Math.min(pageX + rate, radius));
            // display last radius pages
        }
        else if (pageX > pageCount - Math.floor(radius / 2)) {
            return pageNumbers.slice(pageCount - rate - 1, pageCount - 1);
        }
        else {
            // display dispersion of 2 chars from current page (part between dots)
            return pageNumbers.slice(pageX - Math.ceil(radius / 2), Math.min(pageX + Math.floor(radius / 2), pageCount - 1));
        }
    }, [pageCount, pageX]);
    return (_jsxs(Wrapper, { children: [_jsx(Btn, { disabled: pageX <= 1, onClick: setPage(pageX - 1), children: _jsx(GoIcon, { icon: "goLeft", isActive: pageX > 1 }) }), _jsx(PageBtn, { isCurrent: pageX === 1, onClick: setPage(1), children: 1 }), arrayOfPages[0] > 2 && _jsx(DotsWrapper, { children: "..." }), arrayOfPages === null || arrayOfPages === void 0 ? void 0 : arrayOfPages.map(function (number) { return (_jsx(PageBtn, { isCurrent: pageX === number, onClick: setPage(number !== null && number !== void 0 ? number : 1), children: number }, number)); }), arrayOfPages[arrayOfPages.length - 1] < pageCount - 1 && _jsx(DotsWrapper, { children: "..." }), pageCount !== 1 && (_jsx(PageBtn, { isCurrent: pageX === pageCount, onClick: setPage(pageCount), children: pageCount })), _jsx(Btn, { disabled: pageX >= pageCount, onClick: setPage(pageX + 1), children: _jsx(GoIcon, { icon: "goRight", isActive: pageX < pageCount }) })] }));
};
export default Pagination;
